import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from '@ui/dialog.tsx';
import type { VideoNoticeVideoNoticeCollectionReadModel } from '@r/api/generated/client.schemas.ts';
import { useTranslation } from 'react-i18next';

import { VideoNoticeForm } from './video-notice-form.tsx';

interface VideoNoticeDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  videoNotice?: VideoNoticeVideoNoticeCollectionReadModel | null;
}

/**
 * Encapsule le formulaire dans une modale et adapte ses textes au mode création ou édition.
 */
export function VideoNoticeDialog({ isOpen, onOpenChange, videoNotice }: VideoNoticeDialogProps) {
  const { t } = useTranslation();
  const isEditing = Boolean(videoNotice);

  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto p-0">
        <DialogHeader className="border-b px-8 pb-5 pt-8">
          <DialogTitle className="text-2xl">
            {t(
              isEditing
                ? 'fiddy.admin.video.notices.edit.dialog.title'
                : 'fiddy.admin.video.notices.create.dialog.title'
            )}
          </DialogTitle>
          <DialogDescription>
            {t(
              isEditing
                ? 'fiddy.admin.video.notices.edit.dialog.description'
                : 'fiddy.admin.video.notices.create.dialog.description'
            )}
          </DialogDescription>
        </DialogHeader>

        <div className="px-8 pb-8">
          <VideoNoticeForm videoNotice={videoNotice} onSuccess={() => onOpenChange(false)} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
